import React, {useContext, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import Fade from "@material-ui/core/Fade";
import Grow from "@material-ui/core/Grow";
import {AppDataContext} from 'contexts/app-data'

const DialogBox = ({content}) => {
    const {message, cancel, confirm, confirmAction, cancelAction} = content
    const [endLoading, setEndLoading] = useState(false)
    const {dispatch} = useContext(AppDataContext)


    useEffect(()=> {
        setEndLoading(true)

        return function cleanup() {
            setEndLoading(false)
        };
    }, [])

    const handleConfirmAction = () => {
        setEndLoading(false)
        dispatch({type: 'RESET_CONTEXT'})
        setTimeout(function(){confirmAction()},500)

    }
    const handleCancelAction = () => {
        setEndLoading(false)
        setTimeout(function(){cancelAction()},500)

    }

    return (<>
        <div className="dialog-box">
            <Grow in={endLoading} timeout={{ enter: 500, exit: 300}}>
            <div className="dialog-box__wrapper">
                <div className="dialog-box__close fonticons-cross" onClick={handleCancelAction}></div>
                <div className="dialog-box__message"> {message} </div>
                <div className="dialog-box__actions">
                    <div className="dialog-box__actions__cancel" onClick={handleCancelAction}>{cancel}</div>
                        <div className="dialog-box__actions__confirm" onClick={handleConfirmAction}>{confirm}</div>
                </div>
            </div>
            </Grow>


        </div>

        <Fade in={endLoading} timeout={{ enter: 300, exit: 500}} >
        <div className="dialog-box__backdrop"></div>
    </Fade>

</>)
}


DialogBox.propTypes = {
    content: PropTypes.object
};

export default DialogBox